import React from "react";
import { makeStyles, Tooltip } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));

export default ({ children, ...props }) => {
  const classes = useStyles();

  return (
    <Tooltip {...props} classes={classes}>
      {children}
    </Tooltip>
  );
};
